import ConfirmSignup from './ConfirmSignup';

export default ConfirmSignup;
